import React, { useState, useEffect, useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import contentService from '../services/contentService'
import Loading from '../components/Loading'

// ── Toast ─────────────────────────────────────────────────────────────────────
function Toast({ message, type, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 5000)
    return () => clearTimeout(t)
  }, [onClose])
  return (
    <div style={{
      position: 'fixed', top: 20, right: 20, zIndex: 9999,
      display: 'flex', alignItems: 'center', gap: 10,
      padding: '12px 18px', borderRadius: 'var(--g-radius-md)',
      background: type === 'success' ? '#f0fdf4' : '#fef2f2',
      border: `1px solid ${type === 'success' ? '#86efac' : '#fca5a5'}`,
      color: type === 'success' ? '#166534' : '#991b1b',
      boxShadow: 'var(--g-shadow-md)',
      fontSize: 'var(--g-font-size-sm)', fontWeight: 600,
      maxWidth: 360,
    }}>
      <i className={`bi ${type === 'success' ? 'bi-check-circle-fill' : 'bi-exclamation-circle-fill'}`}
         style={{ fontSize: 16, flexShrink: 0 }}></i>
      <span style={{ flex: 1 }}>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', opacity: 0.6, padding: 0, marginLeft: 4 }}>
        <i className="bi bi-x" style={{ fontSize: 18 }}></i>
      </button>
    </div>
  )
}

// ── Badge estado ──────────────────────────────────────────────────────────────
function StatusBadge({ conectado }) {
  return (
    <span className={`g-badge ${conectado ? 'g-badge-success' : 'g-badge-neutral'}`}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
      <span style={{
        width: 6, height: 6, borderRadius: '50%',
        background: conectado ? 'var(--g-lima)' : 'var(--g-text-muted)',
        display: 'inline-block',
      }}></span>
      {conectado ? 'Conectado' : 'No conectado'}
    </span>
  )
}

// ── Card cuenta Instagram ─────────────────────────────────────────────────────
function InstagramAccountCard({ cuenta }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12,
      padding: '12px 16px',
      background: 'var(--g-fondo)',
      borderRadius: 'var(--g-radius-md)',
      border: '1px solid var(--g-border)',
    }}>
      {cuenta.profile_pic_url ? (
        <img src={cuenta.profile_pic_url} alt=""
          style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
          onError={e => { e.target.style.display = 'none' }} />
      ) : (
        <div style={{
          width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
          background: 'linear-gradient(135deg, #8b5cf6, #ec4899)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <i className="bi bi-instagram" style={{ color: '#fff', fontSize: 16 }}></i>
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ margin: 0, fontWeight: 700, fontSize: 'var(--g-font-size-md)', color: 'var(--g-dark)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          @{cuenta.username}
        </p>
        {cuenta.nombre && (
          <p style={{ margin: 0, fontSize: 'var(--g-font-size-xs)', color: 'var(--g-text-muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {cuenta.nombre}
          </p>
        )}
      </div>
      <div style={{ textAlign: 'right', flexShrink: 0 }}>
        <p style={{ margin: 0, fontWeight: 800, fontSize: 'var(--g-font-size-lg)', color: 'var(--g-dark)' }}>
          {cuenta.seguidores ? cuenta.seguidores.toLocaleString('es-CL') : '—'}
        </p>
        <p style={{ margin: 0, fontSize: 'var(--g-font-size-xs)', color: 'var(--g-text-muted)' }}>seguidores</p>
      </div>
    </div>
  )
}

// ── Card página Facebook ──────────────────────────────────────────────────────
function FacebookPageCard({ pagina }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12,
      padding: '12px 16px',
      background: 'var(--g-fondo)',
      borderRadius: 'var(--g-radius-md)',
      border: '1px solid var(--g-border)',
    }}>
      {pagina.picture_url ? (
        <img src={pagina.picture_url} alt=""
          style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
          onError={e => { e.target.style.display = 'none' }} />
      ) : (
        <div style={{
          width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
          background: '#1877F2',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <i className="bi bi-facebook" style={{ color: '#fff', fontSize: 16 }}></i>
        </div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ margin: 0, fontWeight: 700, fontSize: 'var(--g-font-size-md)', color: 'var(--g-dark)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {pagina.nombre}
        </p>
        {pagina.categoria && (
          <p style={{ margin: 0, fontSize: 'var(--g-font-size-xs)', color: 'var(--g-text-muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {pagina.categoria}
          </p>
        )}
      </div>
      <div style={{ textAlign: 'right', flexShrink: 0 }}>
        <p style={{ margin: 0, fontWeight: 800, fontSize: 'var(--g-font-size-lg)', color: 'var(--g-dark)' }}>
          {pagina.fans ? pagina.fans.toLocaleString('es-CL') : '—'}
        </p>
        <p style={{ margin: 0, fontSize: 'var(--g-font-size-xs)', color: 'var(--g-text-muted)' }}>fans</p>
      </div>
    </div>
  )
}

// ── Sección plataforma ────────────────────────────────────────────────────────
function PlatformSection({ icon, iconStyle, title, description, conectado, loading, children, onSincronizar, sincronizando }) {
  return (
    <div className="g-card">
      <div className="g-card-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, flex: 1, minWidth: 0 }}>
          <div style={{
            width: 44, height: 44, borderRadius: 'var(--g-radius-md)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            ...iconStyle,
          }}>
            <i className={`bi ${icon}`} style={{ color: '#fff', fontSize: 20 }}></i>
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <span className="g-card-header-title">{title}</span>
              <StatusBadge conectado={conectado} />
            </div>
            <p style={{ margin: 0, fontSize: 'var(--g-font-size-xs)', color: 'var(--g-text-muted)', marginTop: 2 }}>{description}</p>
          </div>
        </div>
        {onSincronizar && (
          <button
            onClick={onSincronizar}
            disabled={sincronizando}
            className="g-btn g-btn-secondary"
            style={{ fontSize: 'var(--g-font-size-xs)', padding: '6px 14px', flexShrink: 0 }}
          >
            <i className={`bi bi-arrow-clockwise ${sincronizando ? 'spin' : ''}`}></i>
            Sincronizar
          </button>
        )}
      </div>
      <div className="g-card-body">
        {loading ? (
          <Loading fullScreen={false} size="sm" mensaje="Cargando" />
        ) : children}
      </div>
    </div>
  )
}

// ── Empty state ───────────────────────────────────────────────────────────────
function EmptyState({ icon, title, desc, action }) {
  return (
    <div className="g-empty">
      <i className={`bi ${icon} g-empty-icon`}></i>
      <p className="g-empty-title">{title}</p>
      {desc && <p className="g-empty-desc">{desc}</p>}
      {action}
    </div>
  )
}

// ── Main Page ─────────────────────────────────────────────────────────────────
export default function CuentasConectadasPage() {
  const [searchParams] = useSearchParams()

  const [metaConectado, setMetaConectado]     = useState(false)
  const [loadingMeta, setLoadingMeta]         = useState(true)
  const [conectando, setConectando]           = useState(false)
  const [conectandoAds, setConectandoAds]     = useState(false)
  const [adAccounts, setAdAccounts]           = useState(null)   // null = no verificado aún
  const [verificandoAds, setVerificandoAds]   = useState(false)
  const [adsError, setAdsError]               = useState('')
  const [desconectando, setDesconectando]     = useState(false)

  const [cuentasIG, setCuentasIG]             = useState([])
  const [sincronizandoIG, setSincronizandoIG] = useState(false)

  const [paginasFB, setPaginasFB]             = useState([])
  const [loadingFB, setLoadingFB]             = useState(false)
  const [sincronizandoFB, setSincronizandoFB] = useState(false)

  const [toast, setToast] = useState(null)
  const showToast = (message, type = 'success') => setToast({ message, type })

  const cargarIG = useCallback(async () => {
    try {
      const { data } = await contentService.getInstagramMetaEstado()
      setMetaConectado(data.conectado)
      setCuentasIG(data.cuentas || [])
    } catch { /* silencioso */ }
  }, [])

  const cargarFB = useCallback(async () => {
    setLoadingFB(true)
    try {
      const { data } = await contentService.getFacebookMetaEstado()
      setPaginasFB(data.paginas || [])
    } catch { /* silencioso */ }
    finally { setLoadingFB(false) }
  }, [])

  useEffect(() => {
    if (searchParams.get('meta_connected') === '1') showToast('Cuentas conectadas correctamente ✓')
    if (searchParams.get('meta_error'))             showToast('Error al conectar con Meta.', 'error')
    setLoadingMeta(true)
    Promise.all([cargarIG(), cargarFB()]).finally(() => setLoadingMeta(false))
  }, [cargarIG, cargarFB, searchParams])

  const handleConectar = async () => {
    setConectando(true)
    try {
      const { data } = await contentService.getMetaOAuthUrl()
      window.location.href = data.url
    } catch {
      showToast('No se pudo obtener la URL de autenticación de Meta', 'error')
      setConectando(false)
    }
  }

  const handleConectarAds = async () => {
    setConectandoAds(true)
    try {
      const { data } = await contentService.getMetaAdsOAuthUrl()
      window.location.href = data.url
    } catch {
      showToast('No se pudo obtener la URL de autenticación de Meta Ads', 'error')
      setConectandoAds(false)
    }
  }

  const handleVerificarAds = useCallback(async () => {
    setVerificandoAds(true)
    setAdsError('')
    try {
      const { data } = await contentService.getMetaAdAccounts()
      setAdAccounts(data.ad_accounts || [])
      if (!data.ad_accounts || data.ad_accounts.length === 0) {
        setAdsError('Conectado, pero no se encontraron cuentas publicitarias asociadas a tu usuario.')
      }
    } catch (err) {
      setAdAccounts([])
      const msg = err?.response?.data?.hint || err?.response?.data?.error || 'No se pudo verificar (falta el permiso ads_read).'
      setAdsError(msg)
    } finally {
      setVerificandoAds(false)
    }
  }, [])

  useEffect(() => {
    if (searchParams.get('meta_connected') === '1' && metaConectado) {
      // Después de reconectar (con o sin ads_read), verificamos si quedó disponible
      handleVerificarAds()
    }
  }, [searchParams, metaConectado, handleVerificarAds])

  const handleConectarIG = async () => {
    setConectando(true)
    try {
      const { data } = await contentService.getIgBusinessOAuthUrl()
      window.location.href = data.url
    } catch {
      showToast('No se pudo obtener la URL de Instagram', 'error')
      setConectando(false)
    }
  }

  const handleDesconectar = async () => {
    if (!window.confirm('¿Desconectar Meta? Se eliminarán las cuentas Instagram y páginas Facebook vinculadas.')) return
    setDesconectando(true)
    try {
      await contentService.desconectarInstagramMeta()
      setMetaConectado(false)
      setCuentasIG([])
      setPaginasFB([])
      showToast('Cuenta Meta desconectada')
    } catch {
      showToast('Error al desconectar', 'error')
    } finally { setDesconectando(false) }
  }

  const handleSincronizarIG = async () => {
    setSincronizandoIG(true)
    try {
      const { data } = await contentService.sincronizarInstagramMeta()
      setCuentasIG(data.cuentas || [])
      showToast('Cuentas Instagram sincronizadas')
    } catch {
      showToast('Error al sincronizar Instagram', 'error')
    } finally { setSincronizandoIG(false) }
  }

  const handleSincronizarFB = async () => {
    setSincronizandoFB(true)
    try {
      await contentService.sincronizarFacebookMeta()
      await cargarFB()
      showToast('Páginas Facebook sincronizadas')
    } catch {
      showToast('Error al sincronizar Facebook', 'error')
    } finally { setSincronizandoFB(false) }
  }

  return (
    <div className="g-page">
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

      {/* ── Header ───────────────────────────────────────────────────────── */}
      <div className="g-page-header">
        <div>
          <h1 className="g-page-title">
            <i className="bi bi-plug-fill" style={{ marginRight: 10, color: 'var(--g-lima)' }}></i>
            Cuentas Conectadas
          </h1>
          <p className="g-page-subtitle">Administra las cuentas de Instagram y Facebook vinculadas a través de Meta.</p>
        </div>
      </div>

      <div style={{ maxWidth: 720, display: 'flex', flexDirection: 'column', gap: 16 }}>

        {/* ── Panel Meta OAuth ─────────────────────────────────────────── */}
        <div className="g-card">
          <div className="g-card-header">
            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
              {/* Meta logo */}
              <div style={{
                width: 44, height: 44, borderRadius: 'var(--g-radius-md)',
                background: '#000',
                display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
              }}>
                <img
                  src="https://gevesmaicaobucket.fra1.cdn.digitaloceanspaces.com/media/meta_logo.png"
                  alt="Meta"
                  style={{ width: 26, height: 26, objectFit: 'contain' }}
                />
              </div>
              <div>
                <p style={{ margin: 0, fontWeight: 700, fontSize: 'var(--g-font-size-md)', color: 'var(--g-dark)' }}>
                  Meta — Facebook & Instagram
                </p>
                <p style={{ margin: 0, fontSize: 'var(--g-font-size-xs)', color: 'var(--g-text-muted)' }}>
                  App: Analytics Geves 2
                </p>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <StatusBadge conectado={metaConectado} />
              {metaConectado ? (
                <>
                  <button onClick={handleConectar} disabled={conectando} className="g-btn g-btn-secondary"
                    style={{ fontSize: 'var(--g-font-size-xs)', padding: '6px 14px' }}>
                    <i className="bi bi-arrow-repeat"></i>
                    Reconectar
                  </button>
                  <button onClick={handleDesconectar} disabled={desconectando} className="g-btn g-btn-danger"
                    style={{ fontSize: 'var(--g-font-size-xs)', padding: '6px 14px' }}>
                    {desconectando
                      ? <span className="g-spinner" style={{ width: 12, height: 12, borderWidth: 2 }}></span>
                      : <i className="bi bi-plug-fill"></i>}
                    Desconectar
                  </button>
                </>
              ) : !loadingMeta && (
                <button onClick={handleConectar} disabled={conectando} className="g-btn g-btn-primary">
                  {conectando
                    ? <span className="g-spinner" style={{ width: 14, height: 14, borderWidth: 2, borderColor: 'rgba(0,0,0,0.2)', borderTopColor: 'var(--g-dark)' }}></span>
                    : <i className="bi bi-facebook"></i>}
                  Conectar con Meta
                </button>
              )}
            </div>
          </div>

          {/* Permisos */}
          <div className="g-card-body" style={{ paddingTop: 14, paddingBottom: 14 }}>
            <p style={{ margin: '0 0 8px', fontSize: 'var(--g-font-size-xs)', fontWeight: 700, color: 'var(--g-text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
              <i className="bi bi-shield-check-fill" style={{ marginRight: 5 }}></i>Permisos utilizados
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {['instagram_basic', 'instagram_manage_insights', 'pages_show_list', 'pages_read_engagement'].map(p => (
                <code key={p} style={{
                  padding: '3px 8px', borderRadius: 'var(--g-radius-sm)',
                  background: 'var(--g-fondo)', border: '1px solid var(--g-border)',
                  fontSize: 11, color: 'var(--g-text-sec)', fontFamily: 'monospace',
                }}>{p}</code>
              ))}
            </div>
          </div>
        </div>

        {/* ── Panel Marketing API (Ads Insights) — adicional, opcional ──── */}
        {metaConectado && (
          <div className="g-card">
            <div className="g-card-header">
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <div style={{
                  width: 44, height: 44, borderRadius: 'var(--g-radius-md)',
                  background: '#eef2ff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                  <i className="bi bi-megaphone-fill" style={{ color: '#4338ca', fontSize: 20 }}></i>
                </div>
                <div>
                  <p style={{ margin: 0, fontWeight: 700, fontSize: 'var(--g-font-size-md)', color: 'var(--g-dark)' }}>
                    Datos de Ads (Marketing API)
                  </p>
                  <p style={{ margin: 0, fontSize: 'var(--g-font-size-xs)', color: 'var(--g-text-muted)' }}>
                    Opcional — para ver interacciones/seguidores de anuncios en Reporte Geves
                  </p>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {adAccounts && adAccounts.length > 0 && (
                  <span style={{
                    padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700,
                    background: '#ecfdf5', color: '#047857',
                  }}>● ads_read activo</span>
                )}
                <button onClick={handleVerificarAds} disabled={verificandoAds} className="g-btn g-btn-secondary"
                  style={{ fontSize: 'var(--g-font-size-xs)', padding: '6px 14px' }}>
                  {verificandoAds
                    ? <span className="g-spinner" style={{ width: 12, height: 12, borderWidth: 2 }}></span>
                    : <i className="bi bi-search"></i>}
                  Verificar
                </button>
                <button onClick={handleConectarAds} disabled={conectandoAds} className="g-btn g-btn-secondary"
                  style={{ fontSize: 'var(--g-font-size-xs)', padding: '6px 14px' }}>
                  {conectandoAds
                    ? <span className="g-spinner" style={{ width: 12, height: 12, borderWidth: 2 }}></span>
                    : <i className="bi bi-arrow-repeat"></i>}
                  Conectar datos de Ads
                </button>
              </div>
            </div>
            <div className="g-card-body" style={{ paddingTop: 14, paddingBottom: 14 }}>
              <p style={{ margin: '0 0 8px', fontSize: 'var(--g-font-size-xs)', color: 'var(--g-text-muted)' }}>
                Esto vuelve a pedir autorización a Meta agregando el permiso <code style={{ fontSize: 11 }}>ads_read</code> (solo lectura) para
                traer spend, alcance e interacciones de tus campañas desde Ads Manager. No afecta tu conexión actual de Instagram/Facebook.
                Usa "Verificar" para confirmar si el permiso quedó activo (Meta no lo indica en pantalla al reconectar).
              </p>
              {adsError && (
                <p style={{ margin: '0 0 8px', fontSize: 'var(--g-font-size-xs)', color: '#b91c1c' }}>
                  <i className="bi bi-exclamation-triangle-fill" style={{ marginRight: 5 }}></i>{adsError}
                </p>
              )}
              {adAccounts && adAccounts.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {adAccounts.map(a => (
                    <code key={a.id} style={{
                      padding: '3px 8px', borderRadius: 'var(--g-radius-sm)',
                      background: 'var(--g-fondo)', border: '1px solid var(--g-border)',
                      fontSize: 11, color: 'var(--g-text-sec)', fontFamily: 'monospace',
                    }}>{a.name || a.id} ({a.id})</code>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* ── Pantalla de conexión (sin Meta) ──────────────────────────── */}
        {!loadingMeta && !metaConectado && (
          <div className="g-card">
            <div className="g-card-body" style={{ textAlign: 'center', padding: '48px 24px' }}>
              <div style={{
                width: 72, height: 72, borderRadius: 'var(--g-radius-xl)',
                background: 'linear-gradient(135deg, #8b5cf6, #ec4899, #f97316)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 20px', boxShadow: '0 8px 24px rgba(236,72,153,0.25)',
              }}>
                <i className="bi bi-instagram" style={{ color: '#fff', fontSize: 32 }}></i>
              </div>
              <p style={{ margin: '0 0 6px', fontWeight: 800, fontSize: 'var(--g-font-size-xl)', color: 'var(--g-dark)' }}>
                Conecta con Meta
              </p>
              <p style={{ margin: '0 0 24px', fontSize: 'var(--g-font-size-sm)', color: 'var(--g-text-muted)', maxWidth: 380, marginLeft: 'auto', marginRight: 'auto' }}>
                Autoriza el acceso a tus Facebook Pages para vincular tus cuentas Instagram Business y ver métricas de alcance, impresiones y publicaciones.
              </p>
              <button onClick={handleConectarIG} disabled={conectando} className="g-btn g-btn-primary"
                style={{ fontSize: 'var(--g-font-size-md)', padding: '10px 28px', background: 'linear-gradient(135deg,#f58529,#dd2a7b,#8134af)', border: 'none', color: '#fff', marginBottom: 10 }}>
                {conectando
                  ? <span className="g-spinner" style={{ width: 14, height: 14, borderWidth: 2, borderColor: 'rgba(255,255,255,0.3)', borderTopColor: '#fff' }}></span>
                  : <i className="bi bi-instagram"></i>}
                Continuar con Instagram
              </button>
              <button onClick={handleConectar} disabled={conectando} className="g-btn g-btn-primary"
                style={{ fontSize: 'var(--g-font-size-md)', padding: '10px 28px', background: '#1877F2', borderColor: '#1877F2', color: '#fff' }}>
                {conectando
                  ? <span className="g-spinner" style={{ width: 14, height: 14, borderWidth: 2, borderColor: 'rgba(255,255,255,0.3)', borderTopColor: '#fff' }}></span>
                  : <i className="bi bi-facebook"></i>}
                Continuar con Facebook
              </button>
            </div>
          </div>
        )}

        {/* ── Loading inicial ───────────────────────────────────────────── */}
        {loadingMeta && (
          <Loading fullScreen={false} mensaje="Cargando" />
        )}

        {/* ── Instagram ────────────────────────────────────────────────── */}
        {!loadingMeta && metaConectado && (
          <PlatformSection
            icon="bi-instagram"
            iconStyle={{ background: 'linear-gradient(135deg, #8b5cf6, #ec4899)' }}
            title="Instagram Business"
            description="Cuentas Instagram Business vinculadas a tus Facebook Pages"
            conectado={cuentasIG.length > 0}
            loading={false}
            onSincronizar={handleSincronizarIG}
            sincronizando={sincronizandoIG}
          >
            {cuentasIG.length === 0 ? (
              <EmptyState
                icon="bi-instagram"
                title="Sin cuentas Instagram Business"
                desc="Asegúrate de que tu cuenta Facebook tiene al menos una Page con una Instagram Business Account vinculada."
                action={
                  <button onClick={handleSincronizarIG} disabled={sincronizandoIG} className="g-btn g-btn-secondary">
                    <i className={`bi bi-arrow-clockwise ${sincronizandoIG ? 'spin' : ''}`}></i>
                    Volver a sincronizar
                  </button>
                }
              />
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {cuentasIG.map(cuenta => (
                  <InstagramAccountCard key={cuenta.ig_user_id} cuenta={cuenta} />
                ))}
                {cuentasIG[0]?.sincronizado_en && (
                  <p style={{ margin: '4px 0 0', fontSize: 'var(--g-font-size-xs)', color: 'var(--g-text-muted)' }}>
                    <i className="bi bi-clock" style={{ marginRight: 4 }}></i>
                    Última sincronización: {new Date(cuentasIG[0].sincronizado_en).toLocaleString('es-CL', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                  </p>
                )}
              </div>
            )}
          </PlatformSection>
        )}

        {/* ── Facebook ─────────────────────────────────────────────────── */}
        {!loadingMeta && metaConectado && (
          <PlatformSection
            icon="bi-facebook"
            iconStyle={{ background: '#1877F2' }}
            title="Facebook Pages"
            description="Páginas de Facebook conectadas para acceder a métricas e insights"
            conectado={paginasFB.length > 0}
            loading={loadingFB}
            onSincronizar={handleSincronizarFB}
            sincronizando={sincronizandoFB}
          >
            {paginasFB.length === 0 ? (
              <EmptyState
                icon="bi-facebook"
                title="Sin páginas de Facebook"
                desc="No se encontraron páginas de Facebook vinculadas a esta conexión."
                action={
                  <button onClick={handleSincronizarFB} disabled={sincronizandoFB} className="g-btn g-btn-secondary">
                    <i className={`bi bi-arrow-clockwise ${sincronizandoFB ? 'spin' : ''}`}></i>
                    Volver a sincronizar
                  </button>
                }
              />
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {paginasFB.map(pagina => (
                  <FacebookPageCard key={pagina.page_id} pagina={pagina} />
                ))}
              </div>
            )}
          </PlatformSection>
        )}

      </div>

      <style>{`
        .spin { animation: spin 0.8s linear infinite; }
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        .g-spinner {
          width: 28px; height: 28px;
          border: 3px solid var(--g-border);
          border-top-color: var(--g-lima);
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
          display: inline-block;
        }
        .g-btn-danger {
          background: #fff0f0;
          color: #dc2626;
          border-color: #fca5a5;
        }
        .g-btn-danger:hover:not(:disabled) {
          background: #fee2e2;
          border-color: #f87171;
        }
      `}</style>
    </div>
  )
}
